
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
class $cccad717ea460674$export$bc644a473284d944 {
    constructor(x, y){
        this.position = {
            x: x,
            y: y
        };
        this.velocity = {
            x: 0,
            y: 0
        };
        this.rotation = 0;
        this.scale = {
            x: 1,
            y: 1
        };
        this.active = true;
    }
    update(deltaTime) {
        this.position.x += this.velocity.x * deltaTime;
        this.position.y += this.velocity.y * deltaTime;
    }
    draw(ctx) {
    // Base draw method - to be overridden
    }
}


class $d4c3d98f5693b630$export$1c313b81a43a728a {
    static parsePathToVertices(pathData, scale = 1) {
        const vertices = [];
        const commands = pathData.match(/[a-zA-Z][^a-zA-Z]*/g) || [];
        let currentX = 0;
        let currentY = 0;
        commands.forEach((command)=>{
            const type = command[0];
            const args = command.slice(1).trim().split(/[\s,]+/).map(Number);
            switch(type){
                case 'M':
                    currentX = args[0] * scale;
                    currentY = args[1] * scale;
                    vertices.push(currentX, currentY, 0);
                    break;
                case 'L':
                    currentX = args[0] * scale;
                    currentY = args[1] * scale;
                    vertices.push(currentX, currentY, 0);
                    break;
            }
        });
        return new Float32Array(vertices);
    }
}


class $8bd829d56fe01844$export$9a8260d3e4a53cff {
    constructor(gl, shaderProgram){
        this.gl = gl;
        this.shaderProgram = shaderProgram;
        // Modern spaceship shape (flipped vertically)
        const shipPath = `
            M 0 0.08     // Top point
            L -0.06 -0.08  // Bottom left
            L -0.04 -0.06
            L -0.02 -0.08
            L 0 -0.06
            L 0.02 -0.08
            L 0.04 -0.06
            L 0.06 -0.08  // Bottom right
            Z
        `;
        // Create vertices from SVG path
        this.vertices = (0, $d4c3d98f5693b630$export$1c313b81a43a728a).parsePathToVertices(shipPath, 1);
        this.buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
        gl.bufferData(gl.ARRAY_BUFFER, this.vertices, gl.STATIC_DRAW);
    }
    draw(gl, modelMatrix) {
        this.shaderProgram.use();
        gl.uniformMatrix4fv(this.shaderProgram.getUniformLocation('uModelMatrix'), false, modelMatrix);
        // Player ship gradient colors
        gl.uniform3f(this.shaderProgram.getUniformLocation('uColor'), 0.4, 0.6, 1.0 // Blue-ish color
        );
        gl.uniform1f(this.shaderProgram.getUniformLocation('uAlpha'), 1.0);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
        const positionLocation = this.shaderProgram.getAttribLocation('aPosition');
        gl.vertexAttribPointer(positionLocation, 3, gl.FLOAT, false, 0, 0);
        gl.enableVertexAttribArray(positionLocation);
        gl.drawArrays(gl.TRIANGLE_FAN, 0, this.vertices.length / 3);
    }
}


var $2f074ae2c798910c$exports = {};

$parcel$export($2f074ae2c798910c$exports, "create", () => $2f074ae2c798910c$export$185802fd694ee1f5);
$parcel$export($2f074ae2c798910c$exports, "clone", () => $2f074ae2c798910c$export$9cd59f9826255e47);
$parcel$export($2f074ae2c798910c$exports, "copy", () => $2f074ae2c798910c$export$784d13d8ee351f07);
$parcel$export($2f074ae2c798910c$exports, "fromValues", () => $2f074ae2c798910c$export$a82be99ed2a44a7d);
$parcel$export($2f074ae2c798910c$exports, "set", () => $2f074ae2c798910c$export$adaa4cf7ef1b65be);
$parcel$export($2f074ae2c798910c$exports, "identity", () => $2f074ae2c798910c$export$f0954fd7d5368655);
$parcel$export($2f074ae2c798910c$exports, "transpose", () => $2f074ae2c798910c$export$9cb09a71b7d66923);
$parcel$export($2f074ae2c798910c$exports, "invert", () => $2f074ae2c798910c$export$6897c284b6f9f4dc);
$parcel$export($2f074ae2c798910c$exports, "adjoint", () => $2f074ae2c798910c$export$33f3c024b4ae00a1);
$parcel$export($2f074ae2c798910c$exports, "determinant", () => $2f074ae2c798910c$export$a04698f914c55ed9);
$parcel$export($2f074ae2c798910c$exports, "multiply", () => $2f074ae2c798910c$export$2060d2db72cce88f);
$parcel$export($2f074ae2c798910c$exports, "translate", () => $2f074ae2c798910c$export$d73ee8ef04f5226a);
$parcel$export($2f074ae2c798910c$exports, "scale", () => $2f074ae2c798910c$export$dcdf75081b88279d);
$parcel$export($2f074ae2c798910c$exports, "rotate", () => $2f074ae2c798910c$export$bb628a54ab399bc9);
$parcel$export($2f074ae2c798910c$exports, "rotateX", () => $2f074ae2c798910c$export$a59c8716592e09af);
$parcel$export($2f074ae2c798910c$exports, "rotateY", () => $2f074ae2c798910c$export$cf71e4d4ca4d1cfd);
$parcel$export($2f074ae2c798910c$exports, "rotateZ", () => $2f074ae2c798910c$export$ea6eae3365de5b9c);
$parcel$export($2f074ae2c798910c$exports, "fromTranslation", () => $2f074ae2c798910c$export$bc9e79e74e9fddf6);
$parcel$export($2f074ae2c798910c$exports, "fromScaling", () => $2f074ae2c798910c$export$832ca188ffb1955d);
$parcel$export($2f074ae2c798910c$exports, "fromRotation", () => $2f074ae2c798910c$export$926fc125ff3c666c);
$parcel$export($2f074ae2c798910c$exports, "fromXRotation", () => $2f074ae2c798910c$export$dd47cc2f828c32ef);
$parcel$export($2f074ae2c798910c$exports, "fromYRotation", () => $2f074ae2c798910c$export$7dc997d67d2b7f33);
$parcel$export($2f074ae2c798910c$exports, "fromZRotation", () => $2f074ae2c798910c$export$ad5ddaedc8f405df);
$parcel$export($2f074ae2c798910c$exports, "fromRotationTranslation", () => $2f074ae2c798910c$export$9545ac307f2a256b);
$parcel$export($2f074ae2c798910c$exports, "fromQuat2", () => $2f074ae2c798910c$export$ff497f2be31cc6a);
$parcel$export($2f074ae2c798910c$exports, "getTranslation", () => $2f074ae2c798910c$export$202e99f82f7f0395);
$parcel$export($2f074ae2c798910c$exports, "getScaling", () => $2f074ae2c798910c$export$71dc54d92bd04b57);
$parcel$export($2f074ae2c798910c$exports, "getRotation", () => $2f074ae2c798910c$export$df3937d3b537df0a);
$parcel$export($2f074ae2c798910c$exports, "decompose", () => $2f074ae2c798910c$export$4e06b4a690896b27);
$parcel$export($2f074ae2c798910c$exports, "fromRotationTranslationScale", () => $2f074ae2c798910c$export$ddf9c55c9f2be172);
$parcel$export($2f074ae2c798910c$exports, "fromRotationTranslationScaleOrigin", () => $2f074ae2c798910c$export$1def1f860edc4b1f);
$parcel$export($2f074ae2c798910c$exports, "fromQuat", () => $2f074ae2c798910c$export$2ff2bbe382249af7);
$parcel$export($2f074ae2c798910c$exports, "frustum", () => $2f074ae2c798910c$export$89b5708c387cac6c);
$parcel$export($2f074ae2c798910c$exports, "perspectiveNO", () => $2f074ae2c798910c$export$4cf19729ec9a96b8);
$parcel$export($2f074ae2c798910c$exports, "perspective", () => $2f074ae2c798910c$export$541149539f3a4684);
$parcel$export($2f074ae2c798910c$exports, "perspectiveZO", () => $2f074ae2c798910c$export$294bba99a6af0c0c);
$parcel$export($2f074ae2c798910c$exports, "perspectiveFromFieldOfView", () => $2f074ae2c798910c$export$58ae211c788e338f);
$parcel$export($2f074ae2c798910c$exports, "orthoNO", () => $2f074ae2c798910c$export$c5f65ef3eb668f27);
$parcel$export($2f074ae2c798910c$exports, "ortho", () => $2f074ae2c798910c$export$4f2167e613cfc87b);
$parcel$export($2f074ae2c798910c$exports, "orthoZO", () => $2f074ae2c798910c$export$b1d31ea7b4d854e);
$parcel$export($2f074ae2c798910c$exports, "lookAt", () => $2f074ae2c798910c$export$d924e14fd6d9aa66);
$parcel$export($2f074ae2c798910c$exports, "targetTo", () => $2f074ae2c798910c$export$aa67782f4dc9e52c);
$parcel$export($2f074ae2c798910c$exports, "str", () => $2f074ae2c798910c$export$42d51816ce590c93);
$parcel$export($2f074ae2c798910c$exports, "frob", () => $2f074ae2c798910c$export$326827e8268e9cdb);
$parcel$export($2f074ae2c798910c$exports, "add", () => $2f074ae2c798910c$export$e16d8520af44a096);
$parcel$export($2f074ae2c798910c$exports, "subtract", () => $2f074ae2c798910c$export$4e2d2ead65e5f7e3);
$parcel$export($2f074ae2c798910c$exports, "multiplyScalar", () => $2f074ae2c798910c$export$c697bed75648cdb7);
$parcel$export($2f074ae2c798910c$exports, "multiplyScalarAndAdd", () => $2f074ae2c798910c$export$553579f63bdd7137);
$parcel$export($2f074ae2c798910c$exports, "exactEquals", () => $2f074ae2c798910c$export$f2599a5cf1109d8);
$parcel$export($2f074ae2c798910c$exports, "equals", () => $2f074ae2c798910c$export$e9bab7fafb253603);
$parcel$export($2f074ae2c798910c$exports, "mul", () => $2f074ae2c798910c$export$6e3a27864ab166fe);
$parcel$export($2f074ae2c798910c$exports, "sub", () => $2f074ae2c798910c$export$f93b5905241a7cca);
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $b7998c8eefb9a5b8$export$fd293b15f47e270 = 0.000001;
var $b7998c8eefb9a5b8$export$b67359430d3b1b2 = typeof Float32Array !== "undefined" ? Float32Array : Array;
var $b7998c8eefb9a5b8$export$5ada478c8a628231 = Math.random;
var $b7998c8eefb9a5b8$export$217057687ee20298 = "zyx";
function $b7998c8eefb9a5b8$export$2077e0241d6afd3c(a) {
    if (a >= 0) return Math.round(a);
    return a % 0.5 === 0 ? Math.floor(a) : Math.round(a);
}
function $b7998c8eefb9a5b8$export$cb2c0eb57f5e532c(type) {
    $b7998c8eefb9a5b8$export$b67359430d3b1b2 = type;
}
var $b7998c8eefb9a5b8$var$degree = Math.PI / 180;
var $b7998c8eefb9a5b8$var$radian = 180 / Math.PI;
function $b7998c8eefb9a5b8$export$408b8ee5959eefd5(a) {
    return a * $b7998c8eefb9a5b8$var$degree;
}
function $b7998c8eefb9a5b8$export$c796d9d3e501591f(a) {
    return a * $b7998c8eefb9a5b8$var$radian;
}
function $b7998c8eefb9a5b8$export$e9bab7fafb253603(a, b) {
    var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $b7998c8eefb9a5b8$export$fd293b15f47e270;
    return Math.abs(a - b) <= tolerance * Math.max(1, Math.abs(a), Math.abs(b));
}


function $2f074ae2c798910c$export$185802fd694ee1f5() {
    var out = new $b7998c8eefb9a5b8$export$b67359430d3b1b2(16);
    if ($b7998c8eefb9a5b8$export$b67359430d3b1b2 != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
    }
    out[0] = 1;
    out[5] = 1;
    out[10] = 1;
    out[15] = 1;
    return out;
}
function $2f074ae2c798910c$export$9cd59f9826255e47(a) {
    var out = new $b7998c8eefb9a5b8$export$b67359430d3b1b2(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $2f074ae2c798910c$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $2f074ae2c798910c$export$a82be99ed2a44a7d(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    var out = new $b7998c8eefb9a5b8$export$b67359430d3b1b2(16);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $2f074ae2c798910c$export$adaa4cf7ef1b65be(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $2f074ae2c798910c$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2f074ae2c798910c$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a03 = a[3];
        var a12 = a[6], a13 = a[7];
        var a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}
function $2f074ae2c798910c$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function $2f074ae2c798910c$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32;
    out[0] = a11 * b11 - a12 * b10 + a13 * b09;
    out[1] = a02 * b10 - a01 * b11 - a03 * b09;
    out[2] = a31 * b05 - a32 * b04 + a33 * b03;
    out[3] = a22 * b04 - a21 * b05 - a23 * b03;
    out[4] = a12 * b08 - a10 * b11 - a13 * b07;
    out[5] = a00 * b11 - a02 * b08 + a03 * b07;
    out[6] = a32 * b02 - a30 * b05 - a33 * b01;
    out[7] = a20 * b05 - a22 * b02 + a23 * b01;
    out[8] = a10 * b10 - a11 * b08 + a13 * b06;
    out[9] = a01 * b08 - a00 * b10 - a03 * b06;
    out[10] = a30 * b04 - a31 * b02 + a33 * b00;
    out[11] = a21 * b02 - a20 * b04 - a23 * b00;
    out[12] = a11 * b07 - a10 * b09 - a12 * b06;
    out[13] = a00 * b09 - a01 * b07 + a02 * b06;
    out[14] = a31 * b01 - a30 * b03 - a32 * b00;
    out[15] = a20 * b03 - a21 * b01 + a22 * b00;
    return out;
}
function $2f074ae2c798910c$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b0 = a00 * a11 - a01 * a10;
    var b1 = a00 * a12 - a02 * a10;
    var b2 = a01 * a12 - a02 * a11;
    var b3 = a20 * a31 - a21 * a30;
    var b4 = a20 * a32 - a22 * a30;
    var b5 = a21 * a32 - a22 * a31;
    var b6 = a00 * b5 - a01 * b4 + a02 * b3;
    var b7 = a10 * b5 - a11 * b4 + a12 * b3;
    var b8 = a20 * b2 - a21 * b1 + a22 * b0;
    var b9 = a30 * b2 - a31 * b1 + a32 * b0;
    // Calculate the determinant
    return a13 * b6 - a03 * b7 + a33 * b8 - a23 * b9;
}
function $2f074ae2c798910c$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    // Cache only the current line of the second matrix
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function $2f074ae2c798910c$export$d73ee8ef04f5226a(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function $2f074ae2c798910c$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $2f074ae2c798910c$export$bb628a54ab399bc9(out, a, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.sqrt(x * x + y * y + z * z);
    var s, c, t;
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    var b00, b01, b02;
    var b10, b11, b12;
    var b20, b21, b22;
    if (len < $b7998c8eefb9a5b8$export$fd293b15f47e270) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11];
    // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c;
    // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}
function $2f074ae2c798910c$export$a59c8716592e09af(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}
function $2f074ae2c798910c$export$cf71e4d4ca4d1cfd(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
}
function $2f074ae2c798910c$export$ea6eae3365de5b9c(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}
function $2f074ae2c798910c$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $2f074ae2c798910c$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = v[1];
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = v[2];
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2f074ae2c798910c$export$926fc125ff3c666c(out, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.sqrt(x * x + y * y + z * z);
    var s, c, t;
    if (len < $b7998c8eefb9a5b8$export$fd293b15f47e270) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c;
    out[1] = y * x * t + z * s;
    out[2] = z * x * t - y * s;
    out[3] = 0;
    out[4] = x * y * t - z * s;
    out[5] = y * y * t + c;
    out[6] = z * y * t + x * s;
    out[7] = 0;
    out[8] = x * z * t + y * s;
    out[9] = y * z * t - x * s;
    out[10] = z * z * t + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2f074ae2c798910c$export$dd47cc2f828c32ef(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    // Perform axis-specific matrix multiplication
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = c;
    out[6] = s;
    out[7] = 0;
    out[8] = 0;
    out[9] = -s;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2f074ae2c798910c$export$7dc997d67d2b7f33(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = 0;
    out[2] = -s;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = s;
    out[9] = 0;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2f074ae2c798910c$export$ad5ddaedc8f405df(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = 0;
    out[4] = -s;
    out[5] = c;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2f074ae2c798910c$export$9545ac307f2a256b(out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $2f074ae2c798910c$export$ff497f2be31cc6a(out, a) {
    var translation = new $b7998c8eefb9a5b8$export$b67359430d3b1b2(3);
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7];
    var magnitude = bx * bx + by * by + bz * bz + bw * bw;
    //Only scale if it makes sense
    if (magnitude > 0) {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
    } else {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
    }
    $2f074ae2c798910c$export$9545ac307f2a256b(out, a, translation);
    return out;
}
function $2f074ae2c798910c$export$202e99f82f7f0395(out, mat) {
    out[0] = mat[12];
    out[1] = mat[13];
    out[2] = mat[14];
    return out;
}
function $2f074ae2c798910c$export$71dc54d92bd04b57(out, mat) {
    var m11 = mat[0];
    var m12 = mat[1];
    var m13 = mat[2];
    var m21 = mat[4];
    var m22 = mat[5];
    var m23 = mat[6];
    var m31 = mat[8];
    var m32 = mat[9];
    var m33 = mat[10];
    out[0] = Math.sqrt(m11 * m11 + m12 * m12 + m13 * m13);
    out[1] = Math.sqrt(m21 * m21 + m22 * m22 + m23 * m23);
    out[2] = Math.sqrt(m31 * m31 + m32 * m32 + m33 * m33);
    return out;
}
function $2f074ae2c798910c$export$df3937d3b537df0a(out, mat) {
    var scaling = new $b7998c8eefb9a5b8$export$b67359430d3b1b2(3);
    $2f074ae2c798910c$export$71dc54d92bd04b57(scaling, mat);
    var is1 = 1 / scaling[0];
    var is2 = 1 / scaling[1];
    var is3 = 1 / scaling[2];
    var sm11 = mat[0] * is1;
    var sm12 = mat[1] * is2;
    var sm13 = mat[2] * is3;
    var sm21 = mat[4] * is1;
    var sm22 = mat[5] * is2;
    var sm23 = mat[6] * is3;
    var sm31 = mat[8] * is1;
    var sm32 = mat[9] * is2;
    var sm33 = mat[10] * is3;
    var trace = sm11 + sm22 + sm33;
    var S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out[3] = 0.25 * S;
        out[0] = (sm23 - sm32) / S;
        out[1] = (sm31 - sm13) / S;
        out[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out[3] = (sm23 - sm32) / S;
        out[0] = 0.25 * S;
        out[1] = (sm12 + sm21) / S;
        out[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out[3] = (sm31 - sm13) / S;
        out[0] = (sm12 + sm21) / S;
        out[1] = 0.25 * S;
        out[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out[3] = (sm12 - sm21) / S;
        out[0] = (sm31 + sm13) / S;
        out[1] = (sm23 + sm32) / S;
        out[2] = 0.25 * S;
    }
    return out;
}
function $2f074ae2c798910c$export$4e06b4a690896b27(out_r, out_t, out_s, mat) {
    out_t[0] = mat[12];
    out_t[1] = mat[13];
    out_t[2] = mat[14];
    var m11 = mat[0];
    var m12 = mat[1];
    var m13 = mat[2];
    var m21 = mat[4];
    var m22 = mat[5];
    var m23 = mat[6];
    var m31 = mat[8];
    var m32 = mat[9];
    var m33 = mat[10];
    out_s[0] = Math.sqrt(m11 * m11 + m12 * m12 + m13 * m13);
    out_s[1] = Math.sqrt(m21 * m21 + m22 * m22 + m23 * m23);
    out_s[2] = Math.sqrt(m31 * m31 + m32 * m32 + m33 * m33);
    var is1 = 1 / out_s[0];
    var is2 = 1 / out_s[1];
    var is3 = 1 / out_s[2];
    var sm11 = m11 * is1;
    var sm12 = m12 * is2;
    var sm13 = m13 * is3;
    var sm21 = m21 * is1;
    var sm22 = m22 * is2;
    var sm23 = m23 * is3;
    var sm31 = m31 * is1;
    var sm32 = m32 * is2;
    var sm33 = m33 * is3;
    var trace = sm11 + sm22 + sm33;
    var S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out_r[3] = 0.25 * S;
        out_r[0] = (sm23 - sm32) / S;
        out_r[1] = (sm31 - sm13) / S;
        out_r[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out_r[3] = (sm23 - sm32) / S;
        out_r[0] = 0.25 * S;
        out_r[1] = (sm12 + sm21) / S;
        out_r[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out_r[3] = (sm31 - sm13) / S;
        out_r[0] = (sm12 + sm21) / S;
        out_r[1] = 0.25 * S;
        out_r[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out_r[3] = (sm12 - sm21) / S;
        out_r[0] = (sm31 + sm13) / S;
        out_r[1] = (sm23 + sm32) / S;
        out_r[2] = 0.25 * S;
    }
    return out_r;
}
function $2f074ae2c798910c$export$ddf9c55c9f2be172(out, q, v, s) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $2f074ae2c798910c$export$1def1f860edc4b1f(out, q, v, s, o) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    var ox = o[0];
    var oy = o[1];
    var oz = o[2];
    var out0 = (1 - (yy + zz)) * sx;
    var out1 = (xy + wz) * sx;
    var out2 = (xz - wy) * sx;
    var out4 = (xy - wz) * sy;
    var out5 = (1 - (xx + zz)) * sy;
    var out6 = (yz + wx) * sy;
    var out8 = (xz + wy) * sz;
    var out9 = (yz - wx) * sz;
    var out10 = (1 - (xx + yy)) * sz;
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = 0;
    out[4] = out4;
    out[5] = out5;
    out[6] = out6;
    out[7] = 0;
    out[8] = out8;
    out[9] = out9;
    out[10] = out10;
    out[11] = 0;
    out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
    out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
    out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
    out[15] = 1;
    return out;
}
function $2f074ae2c798910c$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $2f074ae2c798910c$export$89b5708c387cac6c(out, left, right, bottom, top, near, far) {
    var rl = 1 / (right - left);
    var tb = 1 / (top - bottom);
    var nf = 1 / (near - far);
    out[0] = near * 2 * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = near * 2 * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = far * near * 2 * nf;
    out[15] = 0;
    return out;
}
function $2f074ae2c798910c$export$4cf19729ec9a96b8(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2);
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        var nf = 1 / (near - far);
        out[10] = (far + near) * nf;
        out[14] = 2 * far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -2 * near;
    }
    return out;
}
var $2f074ae2c798910c$export$541149539f3a4684 = $2f074ae2c798910c$export$4cf19729ec9a96b8;
function $2f074ae2c798910c$export$294bba99a6af0c0c(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2);
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        var nf = 1 / (near - far);
        out[10] = far * nf;
        out[14] = far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -near;
    }
    return out;
}
function $2f074ae2c798910c$export$58ae211c788e338f(out, fov, near, far) {
    var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
    var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
    var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
    var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
    var xScale = 2.0 / (leftTan + rightTan);
    var yScale = 2.0 / (upTan + downTan);
    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = (upTan - downTan) * yScale * 0.5;
    out[10] = far / (near - far);
    out[11] = -1;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = far * near / (near - far);
    out[15] = 0.0;
    return out;
}
function $2f074ae2c798910c$export$c5f65ef3eb668f27(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
var $2f074ae2c798910c$export$4f2167e613cfc87b = $2f074ae2c798910c$export$c5f65ef3eb668f27;
function $2f074ae2c798910c$export$b1d31ea7b4d854e(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = near * nf;
    out[15] = 1;
    return out;
}
function $2f074ae2c798910c$export$d924e14fd6d9aa66(out, eye, center, up) {
    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
    var eyex = eye[0];
    var eyey = eye[1];
    var eyez = eye[2];
    var upx = up[0];
    var upy = up[1];
    var upz = up[2];
    var centerx = center[0];
    var centery = center[1];
    var centerz = center[2];
    if (Math.abs(eyex - centerx) < $b7998c8eefb9a5b8$export$fd293b15f47e270 && Math.abs(eyey - centery) < $b7998c8eefb9a5b8$export$fd293b15f47e270 && Math.abs(eyez - centerz) < $b7998c8eefb9a5b8$export$fd293b15f47e270) return $2f074ae2c798910c$export$f0954fd7d5368655(out);
    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;
    len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;
    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;
    len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }
    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;
    return out;
}
function $2f074ae2c798910c$export$aa67782f4dc9e52c(out, eye, target, up) {
    var eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
    var z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
    var len = z0 * z0 + z1 * z1 + z2 * z2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        z0 *= len;
        z1 *= len;
        z2 *= len;
    }
    var x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
    len = x0 * x0 + x1 * x1 + x2 * x2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    out[0] = x0;
    out[1] = x1;
    out[2] = x2;
    out[3] = 0;
    out[4] = z1 * x2 - z2 * x1;
    out[5] = z2 * x0 - z0 * x2;
    out[6] = z0 * x1 - z1 * x0;
    out[7] = 0;
    out[8] = z0;
    out[9] = z1;
    out[10] = z2;
    out[11] = 0;
    out[12] = eyex;
    out[13] = eyey;
    out[14] = eyez;
    out[15] = 1;
    return out;
}
function $2f074ae2c798910c$export$42d51816ce590c93(a) {
    return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
function $2f074ae2c798910c$export$326827e8268e9cdb(a) {
    return Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2] + a[3] * a[3] + a[4] * a[4] + a[5] * a[5] + a[6] * a[6] + a[7] * a[7] + a[8] * a[8] + a[9] * a[9] + a[10] * a[10] + a[11] * a[11] + a[12] * a[12] + a[13] * a[13] + a[14] * a[14] + a[15] * a[15]);
}
function $2f074ae2c798910c$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
}
function $2f074ae2c798910c$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
}
function $2f074ae2c798910c$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
}
function $2f074ae2c798910c$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    out[9] = a[9] + b[9] * scale;
    out[10] = a[10] + b[10] * scale;
    out[11] = a[11] + b[11] * scale;
    out[12] = a[12] + b[12] * scale;
    out[13] = a[13] + b[13] * scale;
    out[14] = a[14] + b[14] * scale;
    out[15] = a[15] + b[15] * scale;
    return out;
}
function $2f074ae2c798910c$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
function $2f074ae2c798910c$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7];
    var a8 = a[8], a9 = a[9], a10 = a[10], a11 = a[11];
    var a12 = a[12], a13 = a[13], a14 = a[14], a15 = a[15];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    var b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7];
    var b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11];
    var b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    return Math.abs(a0 - b0) <= $b7998c8eefb9a5b8$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $b7998c8eefb9a5b8$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $b7998c8eefb9a5b8$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $b7998c8eefb9a5b8$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $b7998c8eefb9a5b8$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $b7998c8eefb9a5b8$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $b7998c8eefb9a5b8$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $b7998c8eefb9a5b8$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $b7998c8eefb9a5b8$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= $b7998c8eefb9a5b8$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= $b7998c8eefb9a5b8$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= $b7998c8eefb9a5b8$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= $b7998c8eefb9a5b8$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= $b7998c8eefb9a5b8$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= $b7998c8eefb9a5b8$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= $b7998c8eefb9a5b8$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
var $2f074ae2c798910c$export$6e3a27864ab166fe = $2f074ae2c798910c$export$2060d2db72cce88f;
var $2f074ae2c798910c$export$f93b5905241a7cca = $2f074ae2c798910c$export$4e2d2ead65e5f7e3;


class $d7898e1eff4ad1da$export$2616165974278734 extends (0, $cccad717ea460674$export$bc644a473284d944) {
    constructor(x, y, gl, shaderProgram){
        super(x, y), this.lives = 3, this.shield = 100, this.invulnerable = false, this.score = 0, this.SCREEN_LEFT = -0.95, this.SCREEN_RIGHT = 0.95, this.heatLevel = 0, this.maxHeat = 100, this.heatPerShot = 10 // Increased heat per shot
        , this.coolingRate = 40 // Adjusted cooling rate
        , this.overheatCooldown = false, this.overheatCooldownTime = 1500 // 1.5 seconds cooldown
        , this.lastTimeShot = 0 // Track last shot time
        , this.rapidFireThreshold = 200 // ms between shots for rapid fire
        ;
        this.shaderProgram = shaderProgram;
        this.model = new (0, $8bd829d56fe01844$export$9a8260d3e4a53cff)(gl, shaderProgram);
        this.modelMatrix = (0, $2f074ae2c798910c$exports).create();
    }
    update(deltaTime) {
        super.update(deltaTime);
        // Keep player within screen bounds with proper stopping
        const nextX = this.position.x + this.velocity.x * deltaTime;
        if (nextX <= this.SCREEN_LEFT) {
            // Stop at left boundary
            this.position.x = this.SCREEN_LEFT;
            this.velocity.x = 0;
        } else if (nextX >= this.SCREEN_RIGHT) {
            // Stop at right boundary
            this.position.x = this.SCREEN_RIGHT;
            this.velocity.x = 0;
        } else // Normal movement within bounds
        this.position.x = nextX;
        // Shield regeneration
        if (this.shield < 100) {
            this.shield += deltaTime * 5;
            if (this.shield > 100) this.shield = 100;
        }
        // Handle weapon cooling
        if (!this.overheatCooldown) {
            const coolingAmount = this.coolingRate * deltaTime;
            const timeSinceLastShot = performance.now() - this.lastTimeShot;
            const coolingMultiplier = timeSinceLastShot > 1000 ? 2 : 1;
            this.heatLevel = Math.max(0, this.heatLevel - coolingAmount * coolingMultiplier);
        }
    }
    draw(gl) {
        (0, $2f074ae2c798910c$exports).identity(this.modelMatrix);
        (0, $2f074ae2c798910c$exports).translate(this.modelMatrix, this.modelMatrix, [
            this.position.x,
            this.position.y,
            0
        ]);
        (0, $2f074ae2c798910c$exports).rotate(this.modelMatrix, this.modelMatrix, this.rotation, [
            0,
            0,
            1
        ]);
        (0, $2f074ae2c798910c$exports).scale(this.modelMatrix, this.modelMatrix, [
            this.scale.x,
            this.scale.y,
            1
        ]);
        this.model.draw(gl, this.modelMatrix);
    }
    canShoot() {
        if (this.overheatCooldown) return false;
        // Check rapid fire heat penalty
        const currentTime = performance.now();
        const timeSinceLastShot = currentTime - this.lastTimeShot;
        // Add extra heat for rapid firing
        if (timeSinceLastShot < this.rapidFireThreshold) this.heatLevel += 10; // Penalty for rapid firing
        return this.heatLevel < this.maxHeat;
    }
    shoot() {
        const currentTime = performance.now();
        this.lastTimeShot = currentTime;
        // Calculate heat increase based on firing rate
        let heatIncrease = this.heatPerShot;
        this.heatLevel += heatIncrease;
        // Check for overheat
        if (this.heatLevel >= this.maxHeat) {
            this.overheatCooldown = true;
            this.heatLevel = this.maxHeat;
            // Start overheat recovery
            setTimeout(()=>{
                this.overheatCooldown = false;
                this.heatLevel = this.maxHeat * 0.6; // Start at 60% heat after cooldown
            }, this.overheatCooldownTime);
        }
    }
    getHeatPercentage() {
        return this.heatLevel / this.maxHeat * 100;
    }
    isOverheated() {
        return this.overheatCooldown;
    }
    damage(amount) {
        if (this.invulnerable) return;
        if (this.shield > 0) {
            this.shield -= amount;
            if (this.shield < 0) {
                this.lives--;
                this.shield = 100;
                this.invulnerable = true;
                setTimeout(()=>this.invulnerable = false, 2000);
            }
        } else {
            this.lives--;
            if (this.lives > 0) {
                this.shield = 100;
                this.invulnerable = true;
                setTimeout(()=>this.invulnerable = false, 2000);
            }
        }
    }
}







class $48052c4e4987d6e5$export$58825bda29b44ca2 extends (0, $cccad717ea460674$export$bc644a473284d944) {
    constructor(x, y, gl, shaderProgram){
        super(x, y), this.damage = 25, this.lifeTime = 2, this.speed = 0.8;
        this.velocity.y = this.speed;
        this.shaderProgram = shaderProgram;
        // Create a more interesting projectile shape (energy bolt)
        const projectilePath = `
            M 0 -0.03
            L -0.01 0
            L 0 0.03
            L 0.01 0
            Z
        `;
        this.vertices = (0, $d4c3d98f5693b630$export$1c313b81a43a728a).parsePathToVertices(projectilePath, 1);
        this.buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
        gl.bufferData(gl.ARRAY_BUFFER, this.vertices, gl.STATIC_DRAW);
    }
    update(deltaTime) {
        super.update(deltaTime);
        this.lifeTime -= deltaTime;
        // Check both upper and lower boundaries
        if (this.lifeTime <= 0 || this.position.y > 1.2 || this.position.y < -1.2) this.active = false;
    }
    draw(gl) {
        this.shaderProgram.use();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
        const modelMatrix = (0, $2f074ae2c798910c$exports).create();
        (0, $2f074ae2c798910c$exports).translate(modelMatrix, modelMatrix, [
            this.position.x,
            this.position.y,
            0
        ]);
        gl.uniformMatrix4fv(this.shaderProgram.getUniformLocation('uModelMatrix'), false, modelMatrix);
        // Different color for enemy projectiles
        if (this.velocity.y < 0) gl.uniform3f(this.shaderProgram.getUniformLocation('uColor'), 1.0, 0.2, 0.2); // Red for enemy projectiles
        else gl.uniform3f(this.shaderProgram.getUniformLocation('uColor'), 1.0, 0.9, 0.2); // Yellow for player projectiles
        gl.uniform1f(this.shaderProgram.getUniformLocation('uAlpha'), 1.0);
        const positionLocation = this.shaderProgram.getAttribLocation('aPosition');
        gl.enableVertexAttribArray(positionLocation);
        gl.vertexAttribPointer(positionLocation, 3, gl.FLOAT, false, 0, 0);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    }
}



class $81d2b4b0360c2a50$export$eefe978c73a9a6 extends (0, $cccad717ea460674$export$bc644a473284d944) {
    constructor(x, y, gl, shaderProgram){
        super(x, y), this.health = 100, this.type = 'basic', this.points = 10, this.fireRate = 1 // Shots per second
        , this.lastFired = 0, this.projectiles = [], this.movementPattern = 'sine', this.movementPhase = Math.random() * Math.PI * 2, this.amplitude = 0.3 + Math.random() * 0.3 // Random movement amplitude
        , this.frequency = 0.5 + Math.random() * 1.0 // Random movement frequency
        ;
        this.velocity.y = -0.2 - Math.random() * 0.1; // Random downward speed
        this.shaderProgram = shaderProgram;
        this.gl = gl;
        this.centerX = x;
        // Randomly select movement pattern
        const patterns = [
            'sine',
            'zigzag',
            'chase',
            'circle'
        ];
        this.movementPattern = patterns[Math.floor(Math.random() * patterns.length)];
        // Alien ship shape
        const enemyPath = `
            M 0 -0.06
            L -0.06 0
            L -0.04 0.02
            L -0.06 0.04
            L 0 0.06
            L 0.06 0.04
            L 0.04 0.02
            L 0.06 0
            Z
        `;
        this.vertices = (0, $d4c3d98f5693b630$export$1c313b81a43a728a).parsePathToVertices(enemyPath, 1);
        this.buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
        gl.bufferData(gl.ARRAY_BUFFER, this.vertices, gl.STATIC_DRAW);
        this.fireRate = 0.5 + Math.random() * 0.5;
    }
    setTarget(player) {
        this.targetPlayer = player;
    }
    update(deltaTime) {
        super.update(deltaTime);
        // Update movement based on pattern
        switch(this.movementPattern){
            case 'sine':
                this.moveSineWave(deltaTime);
                break;
            case 'zigzag':
                this.moveZigzag(deltaTime);
                break;
            case 'chase':
                this.moveChasePlayer(deltaTime);
                break;
            case 'circle':
                this.moveCircular(deltaTime);
                break;
        }
        // Smart shooting: Only shoot when roughly aligned with player
        if (this.targetPlayer && this.canShootPlayer()) {
            this.lastFired += deltaTime;
            if (this.lastFired >= 1 / this.fireRate) {
                this.shoot();
                this.lastFired = 0;
            }
        }
        // Check if enemy is off screen
        if (this.position.y < -1.2 || this.position.x < -1.2 || this.position.x > 1.2) this.active = false;
    }
    moveSineWave(deltaTime) {
        this.movementPhase += deltaTime * this.frequency;
        this.position.x = this.centerX + Math.sin(this.movementPhase) * this.amplitude;
    }
    moveZigzag(deltaTime) {
        this.movementPhase += deltaTime * this.frequency;
        this.position.x = this.centerX + (Math.abs(this.movementPhase % 2 - 1) * 2 - 1) * this.amplitude;
    }
    moveChasePlayer(deltaTime) {
        if (this.targetPlayer) {
            const dx = this.targetPlayer.position.x - this.position.x;
            const chaseSpeed = 0.3;
            this.position.x += Math.sign(dx) * chaseSpeed * deltaTime;
        }
    }
    moveCircular(deltaTime) {
        this.movementPhase += deltaTime * this.frequency;
        this.position.x = this.centerX + Math.cos(this.movementPhase) * this.amplitude;
        // Add slight vertical oscillation
        this.position.y += Math.sin(this.movementPhase) * deltaTime * 0.1;
    }
    canShootPlayer() {
        if (!this.targetPlayer) return false;
        // Only shoot if roughly aligned with player and in front
        const dx = Math.abs(this.targetPlayer.position.x - this.position.x);
        const dy = this.targetPlayer.position.y - this.position.y;
        return dx < 0.1 && dy < 0; // Aligned horizontally and player is below
    }
    shoot() {
        const projectile = new (0, $48052c4e4987d6e5$export$58825bda29b44ca2)(this.position.x, this.position.y - 0.1, this.gl, this.shaderProgram);
        projectile.velocity.y = -0.5; // Move downward
        projectile.speed = -0.5; // Set negative speed for enemy projectiles
        return projectile;
    }
    draw(gl) {
        this.shaderProgram.use();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
        const modelMatrix = (0, $2f074ae2c798910c$exports).create();
        (0, $2f074ae2c798910c$exports).translate(modelMatrix, modelMatrix, [
            this.position.x,
            this.position.y,
            0
        ]);
        (0, $2f074ae2c798910c$exports).rotate(modelMatrix, modelMatrix, this.rotation, [
            0,
            0,
            1
        ]);
        (0, $2f074ae2c798910c$exports).scale(modelMatrix, modelMatrix, [
            this.scale.x,
            this.scale.y,
            1
        ]);
        gl.uniformMatrix4fv(this.shaderProgram.getUniformLocation('uModelMatrix'), false, modelMatrix);
        // Enemy ship gradient colors
        gl.uniform3f(this.shaderProgram.getUniformLocation('uColor'), 0.8, 0.2, 0.2 // Red-ish color
        );
        gl.uniform1f(this.shaderProgram.getUniformLocation('uAlpha'), 1.0);
        const positionLocation = this.shaderProgram.getAttribLocation('aPosition');
        gl.enableVertexAttribArray(positionLocation);
        gl.vertexAttribPointer(positionLocation, 3, gl.FLOAT, false, 0, 0);
        gl.drawArrays(gl.TRIANGLE_FAN, 0, this.vertices.length / 3);
    }
    damage(amount) {
        this.health -= amount;
        if (this.health <= 0) this.active = false;
    }
}




class $a02701040fcf9815$export$f219b6a0e4bb0b6d {
    constructor(gl, shaderProgram){
        this.particles = [];
        this.gl = gl;
        this.shaderProgram = shaderProgram;
        // Create square vertices for particles
        this.vertices = new Float32Array([
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            1,
            -1,
            0 // bottom right
        ]);
        this.buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
        gl.bufferData(gl.ARRAY_BUFFER, this.vertices, gl.STATIC_DRAW);
    }
    spawn(x, y, count = 10) {
        for(let i = 0; i < count; i++){
            const angle = Math.random() * Math.PI * 2;
            const speed = Math.random() * 0.2 + 0.1;
            this.particles.push({
                position: {
                    x: x,
                    y: y
                },
                velocity: {
                    x: Math.cos(angle) * speed,
                    y: Math.sin(angle) * speed
                },
                rotation: Math.random() * Math.PI * 2,
                scale: {
                    x: 1,
                    y: 1
                },
                active: true,
                color: '#ffeb3b',
                size: Math.random() * 0.02 + 0.01,
                life: 1.0,
                maxLife: 1.0
            });
        }
    }
    update(deltaTime) {
        this.particles = this.particles.filter((particle)=>{
            particle.life -= deltaTime;
            if (particle.life <= 0) return false;
            particle.position.x += particle.velocity.x * deltaTime;
            particle.position.y += particle.velocity.y * deltaTime;
            particle.velocity.y += 0.5 * deltaTime; // Gravity
            return true;
        });
    }
    draw(gl) {
        if (this.particles.length === 0) return;
        this.shaderProgram.use();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
        const positionLocation = this.shaderProgram.getAttribLocation('aPosition');
        gl.enableVertexAttribArray(positionLocation);
        this.particles.forEach((particle)=>{
            const modelMatrix = (0, $2f074ae2c798910c$exports).create();
            (0, $2f074ae2c798910c$exports).translate(modelMatrix, modelMatrix, [
                particle.position.x,
                particle.position.y,
                0
            ]);
            (0, $2f074ae2c798910c$exports).scale(modelMatrix, modelMatrix, [
                particle.size,
                particle.size,
                1
            ]);
            (0, $2f074ae2c798910c$exports).rotate(modelMatrix, modelMatrix, particle.rotation, [
                0,
                0,
                1
            ]); // Add rotation
            gl.uniformMatrix4fv(this.shaderProgram.getUniformLocation('uModelMatrix'), false, modelMatrix);
            const alpha = particle.life / particle.maxLife;
            // Use different colors for celebration particles
            const brightness = 0.5 + alpha * 0.5; // Fade out smoothly
            gl.uniform3f(this.shaderProgram.getUniformLocation('uColor'), 1.0 * brightness, 0.9 * brightness, 0.2 * brightness);
            gl.uniform1f(this.shaderProgram.getUniformLocation('uAlpha'), alpha);
            gl.vertexAttribPointer(positionLocation, 3, gl.FLOAT, false, 0, 0);
            gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        });
    }
    spawnCelebration(x, y, count = 50) {
        const colors = [
            {
                r: 1.0,
                g: 0.8,
                b: 0.0
            },
            {
                r: 1.0,
                g: 0.6,
                b: 0.0
            },
            {
                r: 1.0,
                g: 0.4,
                b: 0.0
            },
            {
                r: 0.8,
                g: 0.8,
                b: 1.0
            },
            {
                r: 1.0,
                g: 1.0,
                b: 1.0
            } // White
        ];
        for(let i = 0; i < count; i++){
            const angle = Math.random() * Math.PI * 2;
            const speed = Math.random() * 0.5 + 0.2; // Faster than normal particles
            const color = colors[Math.floor(Math.random() * colors.length)];
            this.particles.push({
                position: {
                    x: x,
                    y: y
                },
                velocity: {
                    x: Math.cos(angle) * speed,
                    y: Math.sin(angle) * speed
                },
                rotation: Math.random() * Math.PI * 2,
                scale: {
                    x: 1,
                    y: 1
                },
                active: true,
                color: '#ffeb3b',
                size: Math.random() * 0.03 + 0.02,
                life: 2.0,
                maxLife: 2.0
            });
        }
    }
}


const $82015ed54434dad4$export$33507c450926adec = `
    attribute vec3 aPosition;

    uniform mat4 uModelMatrix;
    uniform mat4 uViewMatrix;
    uniform mat4 uProjectionMatrix;

    void main() {
        gl_Position = uProjectionMatrix * uViewMatrix * uModelMatrix * vec4(aPosition, 1.0);
    }
`;
const $82015ed54434dad4$export$125a88569be3d4c0 = `
    precision mediump float;

    uniform vec3 uColor;
    uniform float uAlpha;

    void main() {
        gl_FragColor = vec4(uColor, uAlpha);
    }
`;


class $0ddc100f28293d0c$export$cb01d642ebc0a347 {
    constructor(gl){
        this.gl = gl;
        this.program = this.createProgram();
    }
    createProgram() {
        const program = this.gl.createProgram();
        const vertexShader = this.createShader(this.gl.VERTEX_SHADER, (0, $82015ed54434dad4$export$33507c450926adec));
        const fragmentShader = this.createShader(this.gl.FRAGMENT_SHADER, (0, $82015ed54434dad4$export$125a88569be3d4c0));
        this.gl.attachShader(program, vertexShader);
        this.gl.attachShader(program, fragmentShader);
        this.gl.linkProgram(program);
        if (!this.gl.getProgramParameter(program, this.gl.LINK_STATUS)) throw new Error(this.gl.getProgramInfoLog(program));
        return program;
    }
    createShader(type, source) {
        const shader = this.gl.createShader(type);
        this.gl.shaderSource(shader, source);
        this.gl.compileShader(shader);
        if (!this.gl.getShaderParameter(shader, this.gl.COMPILE_STATUS)) throw new Error(this.gl.getShaderInfoLog(shader));
        return shader;
    }
    use() {
        this.gl.useProgram(this.program);
    }
    getUniformLocation(name) {
        return this.gl.getUniformLocation(this.program, name);
    }
    getAttribLocation(name) {
        return this.gl.getAttribLocation(this.program, name);
    }
}



class $6b3314c68a1de268$export$5b12bf1653c0dd85 {
    static createProjection(width, height) {
        const projection = (0, $2f074ae2c798910c$exports).create();
        (0, $2f074ae2c798910c$exports).ortho(projection, -width / 2, width / 2, -height / 2, height / 2, -1, 1);
        return projection;
    }
    static createView() {
        return (0, $2f074ae2c798910c$exports).create(); // Identity matrix for 2D
    }
    static createModel(x, y, rotation, scaleX, scaleY) {
        const model = (0, $2f074ae2c798910c$exports).create();
        (0, $2f074ae2c798910c$exports).translate(model, model, [
            x,
            y,
            0
        ]);
        (0, $2f074ae2c798910c$exports).rotate(model, model, rotation, [
            0,
            0,
            1
        ]);
        (0, $2f074ae2c798910c$exports).scale(model, model, [
            scaleX,
            scaleY,
            1
        ]);
        return model;
    }
}



class $9cc62551c2b1784b$export$967f7c22010d1498 {
    constructor(gl, shaderProgram, starCount = 200){
        this.stars = [];
        this.gl = gl;
        this.shaderProgram = shaderProgram;
        // Create square vertices for stars
        this.vertices = new Float32Array([
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            1,
            -1,
            0
        ]);
        this.buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
        gl.bufferData(gl.ARRAY_BUFFER, this.vertices, gl.STATIC_DRAW);
        // Initialize stars
        for(let i = 0; i < starCount; i++)this.stars.push(this.createStar());
    }
    createStar() {
        const colors = [
            {
                r: 1.0,
                g: 1.0,
                b: 1.0
            },
            {
                r: 0.9,
                g: 0.9,
                b: 1.0
            },
            {
                r: 1.0,
                g: 0.9,
                b: 0.9
            },
            {
                r: 0.4,
                g: 0.6,
                b: 1.0
            },
            {
                r: 1.0,
                g: 0.6,
                b: 0.4
            } // Orange
        ];
        return {
            x: Math.random() * 2 - 1,
            y: Math.random() * 2 - 1,
            size: Math.random() * 0.004 + 0.001,
            brightness: Math.random() * 0.5 + 0.5,
            speed: Math.random() * 0.05 + 0.02,
            color: colors[Math.floor(Math.random() * colors.length)]
        };
    }
    update(deltaTime) {
        this.stars.forEach((star)=>{
            star.y -= star.speed * deltaTime;
            // Reset star position when it goes off screen
            if (star.y < -1) {
                star.y = 1;
                star.x = Math.random() * 2 - 1;
                star.size = Math.random() * 0.004 + 0.001;
                star.brightness = Math.random() * 0.5 + 0.5;
            }
        });
    }
    draw(gl) {
        this.shaderProgram.use();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
        const positionLocation = this.shaderProgram.getAttribLocation('aPosition');
        gl.enableVertexAttribArray(positionLocation);
        gl.vertexAttribPointer(positionLocation, 3, gl.FLOAT, false, 0, 0);
        this.stars.forEach((star)=>{
            const modelMatrix = (0, $2f074ae2c798910c$exports).create();
            (0, $2f074ae2c798910c$exports).translate(modelMatrix, modelMatrix, [
                star.x,
                star.y,
                0
            ]);
            (0, $2f074ae2c798910c$exports).scale(modelMatrix, modelMatrix, [
                star.size,
                star.size,
                1
            ]);
            gl.uniformMatrix4fv(this.shaderProgram.getUniformLocation('uModelMatrix'), false, modelMatrix);
            gl.uniform3f(this.shaderProgram.getUniformLocation('uColor'), star.color.r * star.brightness, star.color.g * star.brightness, star.color.b * star.brightness);
            gl.uniform1f(this.shaderProgram.getUniformLocation('uAlpha'), star.brightness);
            gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        });
    }
}


class $1d65543a723a8bec$export$985739bfa5723e08 {
    constructor(canvas){
        this.enemies = [];
        this.projectiles = [];
        this.enemyProjectiles = [];
        this.lastTime = 0;
        this.gameOver = false;
        this.running = false;
        this.score = 0;
        this.highScore = 0;
        this.handleKeyDown = (e)=>{
            if (this.gameOver) return;
            switch(e.code // Use e.code instead of e.key for better cross-browser support
            ){
                case 'ArrowLeft':
                case 'KeyA':
                    this.player.velocity.x = -0.8;
                    break;
                case 'ArrowRight':
                case 'KeyD':
                    this.player.velocity.x = 0.8;
                    break;
                case 'Space':
                    e.preventDefault();
                    this.shoot();
                    break;
            }
        };
        this.handleKeyUp = (e)=>{
            switch(e.code){
                case 'ArrowLeft':
                case 'KeyA':
                    if (this.player.velocity.x < 0) this.player.velocity.x = 0;
                    break;
                case 'ArrowRight':
                case 'KeyD':
                    if (this.player.velocity.x > 0) this.player.velocity.x = 0;
                    break;
            }
        };
        try {
            this.gl = canvas.getContext('webgl', {
                alpha: false,
                antialias: true,
                depth: false
            });
            if (!this.gl) throw new Error('WebGL not supported');
            this.gl.getExtension('WEBGL_lose_context');
            this.gl.getExtension('WEBGL_debug_renderer_info');
            console.log('WebGL Vendor:', this.gl.getParameter(this.gl.VENDOR));
            console.log('WebGL Renderer:', this.gl.getParameter(this.gl.RENDERER));
            console.log('WebGL Version:', this.gl.getParameter(this.gl.VERSION));
            this.loadHighScore();
            this.initGame();
        } catch (error) {
            console.error('Game initialization failed:', error);
            this.showErrorMessage();
        }
    }
    showErrorMessage() {
        const container = document.querySelector('.game-container');
        if (container) container.innerHTML = `
            <div class="error-message" style="text-align: center; padding: 20px;">
                <h2>Oops! Something went wrong</h2>
                <p>Unable to initialize the game. Please check if WebGL is supported in your browser.</p>
            </div>
        `;
    }
    loadHighScore() {
        const savedHighScore = localStorage.getItem('highScore');
        this.highScore = savedHighScore ? parseInt(savedHighScore, 10) : 0;
        this.updateHighScoreDisplay();
    }
    updateHighScoreDisplay() {
        const highScoreElement = document.getElementById('highScoreValue');
        if (highScoreElement) highScoreElement.textContent = this.highScore.toString();
    }
    updateHighScore(score) {
        if (score > this.highScore) {
            this.highScore = score;
            localStorage.setItem('highScore', this.highScore.toString());
            this.updateHighScoreDisplay();
        }
    }
    initGame() {
        // Initialize shader program
        this.shaderProgram = new (0, $0ddc100f28293d0c$export$cb01d642ebc0a347)(this.gl);
        // Setup GL
        this.setupGL();
        // Initialize game objects
        this.starField = new (0, $9cc62551c2b1784b$export$967f7c22010d1498)(this.gl, this.shaderProgram);
        this.player = new (0, $d7898e1eff4ad1da$export$2616165974278734)(0, -0.8, this.gl, this.shaderProgram);
        this.particles = new (0, $a02701040fcf9815$export$f219b6a0e4bb0b6d)(this.gl, this.shaderProgram);
        this.projectiles = [];
        this.enemies = [];
        this.gameOver = false;
        // Reset scores
        this.score = 0;
        this.updateHighScoreDisplay();
        // Show HUD
        const hud = document.querySelector('.hud-top');
        if (hud) hud.style.display = 'flex';
        // Hide game over screen
        const gameOverScreen = document.getElementById('gameOver');
        if (gameOverScreen) gameOverScreen.classList.add('hidden');
        this.lastTime = performance.now();
        // Clear any existing spawn interval
        if (this.spawnInterval) clearInterval(this.spawnInterval);
        // Setup event listeners
        this.setupEventListeners();
        // Start game loop
        this.running = true;
        this.gameLoop(performance.now());
        // Start spawning enemies
        this.spawnEnemies();
    }
    setupGL() {
        this.gl.enable(this.gl.BLEND);
        this.gl.blendFunc(this.gl.SRC_ALPHA, this.gl.ONE_MINUS_SRC_ALPHA);
        this.gl.clearColor(0.06, 0.09, 0.16, 1.0);
        this.gl.viewport(0, 0, this.gl.canvas.width, this.gl.canvas.height);
        // Set up projection and view matrices
        const aspect = this.gl.canvas.width / this.gl.canvas.height;
        const projection = (0, $6b3314c68a1de268$export$5b12bf1653c0dd85).createProjection(2 * aspect, 2);
        const view = (0, $6b3314c68a1de268$export$5b12bf1653c0dd85).createView();
        this.shaderProgram.use();
        this.gl.uniformMatrix4fv(this.shaderProgram.getUniformLocation('uProjectionMatrix'), false, projection);
        this.gl.uniformMatrix4fv(this.shaderProgram.getUniformLocation('uViewMatrix'), false, view);
    }
    setupEventListeners() {
        // Remove old listeners if they exist
        window.removeEventListener('keydown', this.handleKeyDown);
        window.removeEventListener('keyup', this.handleKeyUp);
        // Add new listeners
        window.addEventListener('keydown', this.handleKeyDown.bind(this));
        window.addEventListener('keyup', this.handleKeyUp.bind(this));
    }
    shoot() {
        if (this.gameOver) return;
        // Check if player can shoot
        if (!this.player.canShoot()) return;
        // Mark the shot
        this.player.shoot();
        // Create and add projectile
        const projectile = new (0, $48052c4e4987d6e5$export$58825bda29b44ca2)(this.player.position.x, this.player.position.y + 0.1, this.gl, this.shaderProgram);
        this.projectiles.push(projectile);
    }
    spawnEnemies() {
        if (this.gameOver || !this.running) return;
        if (this.spawnInterval) clearInterval(this.spawnInterval);
        this.spawnInterval = window.setInterval(()=>{
            if (!this.gameOver && this.running) {
                const enemy = new (0, $81d2b4b0360c2a50$export$eefe978c73a9a6)(Math.random() * 1.6 - 0.8, 1.2, this.gl, this.shaderProgram);
                enemy.setTarget(this.player); // Set player as target
                this.enemies.push(enemy);
            }
        }, 2000);
    }
    update(deltaTime) {
        if (this.gameOver) return;
        // Update starfield first
        this.starField.update(deltaTime);
        // Update player
        this.player.update(deltaTime);
        // Update player projectiles
        this.projectiles = this.projectiles.filter((projectile)=>{
            projectile.update(deltaTime);
            return projectile.active;
        });
        // Update enemy projectiles
        this.enemyProjectiles = this.enemyProjectiles.filter((projectile)=>{
            projectile.update(deltaTime);
            return projectile.active;
        });
        // Update enemies and their shooting
        this.enemies = this.enemies.filter((enemy)=>{
            enemy.update(deltaTime);
            // Handle enemy shooting
            enemy.lastFired += deltaTime;
            if (enemy.lastFired >= 1 / enemy.fireRate) {
                const projectile = enemy.shoot();
                this.enemyProjectiles.push(projectile);
                enemy.lastFired = 0;
            }
            return enemy.active;
        });
        // Check collisions
        this.checkCollisions();
        // Update particles
        this.particles.update(deltaTime);
        // Update HUD
        this.updateHUD();
    }
    checkCollisions() {
        // Player projectiles vs Enemies
        this.projectiles.forEach((projectile)=>{
            this.enemies.forEach((enemy)=>{
                if (this.checkCollision(projectile, enemy)) {
                    enemy.damage(projectile.damage);
                    projectile.active = false;
                    if (!enemy.active) {
                        this.player.score += enemy.points;
                        this.particles.spawn(enemy.position.x, enemy.position.y);
                    }
                }
            });
        });
        // Enemy projectiles vs Player
        this.enemyProjectiles.forEach((projectile)=>{
            if (this.checkCollision(projectile, this.player)) {
                this.player.damage(25); // Damage from enemy projectile
                projectile.active = false;
                this.particles.spawn(this.player.position.x, this.player.position.y);
            }
        });
        // Enemies vs Player (collision damage)
        this.enemies.forEach((enemy)=>{
            if (this.checkCollision(enemy, this.player)) {
                this.player.damage(50); // More damage for direct collision
                enemy.active = false;
                this.particles.spawn(enemy.position.x, enemy.position.y);
                this.particles.spawn(this.player.position.x, this.player.position.y);
                if (this.player.lives <= 0) {
                    this.gameOver = true;
                    this.showGameOver();
                }
            }
        });
    }
    checkCollision(a, b) {
        const dx = a.position.x - b.position.x;
        const dy = a.position.y - b.position.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        return distance < 0.1; // Collision radius
    }
    updateHUD() {
        document.getElementById('scoreValue').textContent = this.player.score.toString();
        document.getElementById('livesValue').textContent = this.player.lives.toString();
        document.getElementById('shieldValue').style.width = `${this.player.shield}%`;
        // Update heat indicator
        const heatElement = document.getElementById('shootCooldown');
        if (heatElement) {
            const heatPercent = this.player.getHeatPercentage();
            heatElement.style.width = `${100 - heatPercent}%`;
            // Change color based on heat level
            if (this.player.isOverheated()) heatElement.style.backgroundColor = '#ef4444'; // Red for overheat
            else if (heatPercent > 80) heatElement.style.backgroundColor = '#f97316'; // Orange for high heat
            else if (heatPercent > 50) heatElement.style.backgroundColor = '#eab308'; // Yellow for medium heat
            else heatElement.style.backgroundColor = '#4f46e5'; // Blue for low heat
        }
    }
    showGameOver() {
        this.running = false;
        this.gameOver = true;
        if (this.spawnInterval) clearInterval(this.spawnInterval);
        // Update high score
        this.updateHighScore(this.player.score);
        // Hide HUD
        const hud = document.querySelector('.hud-top');
        if (hud) hud.style.display = 'none';
        // Show game over screen with scores
        const gameOverScreen = document.getElementById('gameOver');
        if (gameOverScreen) {
            gameOverScreen.classList.remove('hidden');
            document.getElementById('finalScore').textContent = this.player.score.toString();
            document.getElementById('finalHighScore').textContent = this.highScore.toString();
        }
        const finalScoreElement = document.getElementById('finalScore');
        const finalHighScoreElement = document.getElementById('finalHighScore');
        finalScoreElement.textContent = this.player.score.toString();
        finalHighScoreElement.textContent = this.highScore.toString();
        // Highlight new high score
        if (this.player.score === this.highScore) {
            finalScoreElement.classList.add('new-high');
            // Spawn celebration particles at multiple points
            this.particles.spawnCelebration(-0.5, 0, 25);
            this.particles.spawnCelebration(0.5, 0, 25);
            this.particles.spawnCelebration(0, 0.5, 25);
            // Add delayed spawns for continuous celebration effect
            setTimeout(()=>{
                this.particles.spawnCelebration(0, 0, 50);
            }, 500);
        } else finalScoreElement.classList.remove('new-high');
    }
    draw() {
        this.gl.clear(this.gl.COLOR_BUFFER_BIT);
        this.starField.draw(this.gl);
        this.player.draw(this.gl);
        this.projectiles.forEach((p)=>p.draw(this.gl));
        this.enemyProjectiles.forEach((p)=>p.draw(this.gl)); // Draw enemy projectiles
        this.enemies.forEach((e)=>e.draw(this.gl));
        this.particles.draw(this.gl);
    }
    gameLoop(currentTime) {
        if (!this.running) return;
        const deltaTime = Math.min((currentTime - this.lastTime) / 1000, 0.1); // Cap delta time
        this.lastTime = currentTime;
        this.update(deltaTime); // Pass deltaTime instead of currentTime
        this.draw();
        requestAnimationFrame((time)=>this.gameLoop(time));
    }
    start() {
        this.gameLoop(performance.now());
    }
    cleanup() {
        this.running = false;
        this.gameOver = true;
        if (this.spawnInterval) {
            clearInterval(this.spawnInterval);
            this.spawnInterval = undefined;
        }
        window.removeEventListener('keydown', this.handleKeyDown);
        window.removeEventListener('keyup', this.handleKeyUp);
    }
}


function $ad2bcec7a0192558$var$startGame() {
    const canvas = document.getElementById('gameCanvas');
    // Set fixed size for predictable gameplay
    canvas.width = 800;
    canvas.height = 600;
    const game = new (0, $1d65543a723a8bec$export$985739bfa5723e08)(canvas);
    game.start(); // Add this line to start the game loop
}
// Start game when page is fully loaded
window.addEventListener('DOMContentLoaded', ()=>{
    $ad2bcec7a0192558$var$startGame();
});
// Handle restart button
document.getElementById('restartButton')?.addEventListener('click', ()=>{
    document.getElementById('gameOver')?.classList.add('hidden'); // Hide game over screen
    $ad2bcec7a0192558$var$startGame();
});


//# sourceMappingURL=space-shooter.16226e65.js.map
